/* Built In Imports */

/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */

import SectionTitle from '@components/HNI/Components/Headings/SectionTitle';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Services */

/**
 * Renders the Highlights component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Highlights component
 */

const Highlights = ({ sectionContent, region, lang }) => {
  const benefitsData = sectionContent[0];
  return (
    <Box
      backgroundSize={{ base: 'contain !important', md: 'cover !important' }}
      pt={{ lg: '3.5rem' }}
      px="20px"
    >
      <Box>
        <Box
          w="100%"
          m={{ base: '0 auto', md: '0 auto' }}
          p={{ base: '6rem 0 0', md: '55px 0 0', lg: '55px 0' }}
          textAlign={{ base: 'center' }}
          // maxW={800}
        >
          <SectionTitle
            titleObj={benefitsData.title[0]}
            color="#FFFFFF"
            fontSize={{ base: '26px', md: '30px' }}
            lineHeight={{ base: '34px', md: '47px' }}
          />
          <Box
            w={{ base: '85%', sm: '50%', xl: '85%' }}
            m={{ base: '0 auto', md: '0 auto' }}
            textAlign={{ base: 'center' }}
            color="white"
          >
            {benefitsData.title[0]?.titleSubtext}
          </Box>
          <Box
            display={{ base: 'flex' }}
            flexDirection={{ base: 'column', sm: 'row' }}
            justifyContent="space-around"
            flexWrap={{ base: 'unset', sm: 'wrap', xl: 'wrap' }}
            gridGap="15px"
            m="25px auto 0 auto"
            w={{ base:'100%', md:'920px'}}
            className='benefitsection'
          >
            {benefitsData &&
              benefitsData?.benefits.map((data, index) => {
                return (
                  <Box
                    w={{ base: '100%', sm: 275 }}
                    maxW={275}
                    minW={{ base: 1, sm: 274 }}
                    mx={{ base: 'auto', md: '0' }}
                    // p="0 10px"
                    flexDir="column"
                    alignItems="start"
                    key={nanoid()}
                    flex="1"
                  >
                    <LazyLoadImageComponent
                      loading="lazy"
                      alt={data?.image?.alt || data?.image?.title || ''}
                      // title={data?.image?.title}
                      h="162px"
                      w={{ base: '100%', sm: 275 }}
                      objectFit="cover"
                      bg="lightgray -6px 0px / 102.92% 89.51% no-repeat"
                      src={data?.image?.url}
                      // m={{ base: '0 auto 22px auto' }}
                      borderRadius={
                        benefitsData?.style === 'default' ? '50%' : ''
                      }
                      rounded="5px"
                    />
                    <Text
                      as="h6"
                      color="#fff"
                      fontFamily="FedraSansStd-book"
                      fontSize="18px"
                      lineHeight="26px"
                      textAlign="center"
                      w={{ base: '90%', sm: index === 0 ? '82%' : '100%' }}
                      //   {...CompWithLeastStyle[lang].highLightContent}
                      m={{ base: '25px 0 27px', lg: '25px auto 15px' }}
                      // w={{ base: '80%', xl: 'auto' }}
                      // px={{ base: '.4rem', md: '2px' }}
                    >
                      {data?.text}
                    </Text>
                  </Box>
                );
              })}
          </Box>
        </Box>
      </Box>
      <style>
        {`
        .benefitsection img {
          background: #181818;
        }
        `}
        </style>
    </Box>
  );
};

export default Highlights;
